export const selectUser = (state) => state.user.user;

export const loginSelector = (state) => state.user.loggedIn;

export const authSelector = (state) => state.user.auth;
